import React, { ReactNode } from "react";

import styled from "@mui/material/styles/styled";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { IconButton, IconButtonProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BaseDialog } from "../dialog/BaseDialog";
import { colors } from "../../theme/colors";

export const AddDialog = styled(BaseDialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "500px",
    maxHeight: "550px",
  },
}));

export const AddDialogTitle = styled(DialogTitle)(() => ({
  backgroundColor: colors.primary,
  color: "white",
  fontWeight: "bold",
  fontSize: "23px",
  textAlign: "center",
}));

export const AddDialogCloseButton: React.FC<IconButtonProps> = (props) => (
  <IconButton
    {...props}
    sx={{
      position: "absolute",
      right: 8,
      top: 8,
      color: "white",
    }}
  >
    <CloseIcon />
  </IconButton>
);

export const AddDialogContent: React.FC<{ children: ReactNode }> = ({
  children,
}) => (
  <DialogContent
    dividers
    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
  >
    {children}
  </DialogContent>
);

export const AddDialogAddButton: React.FC<{
  onClick: () => void;
  disabled: boolean;
  message?: string;
}> = ({ onClick, disabled, message = "追加する" }) => (
  <Button
    variant="contained"
    onClick={onClick}
    disabled={disabled}
    sx={{
      width: "50%",
      color: colors.primary,
      alignSelf: "center",
      backgroundColor: "white",
      borderRadius: "16px",
      border: `2px solid ${colors.primary}`,
      fontSize: "15px",
      "&:hover": {
        color: "white",
        transform: "scale(1.1)",
        backgroundColor: colors.primary,
      },
    }}
  >
    {message}
  </Button>
);
